import * as SharpDataService from "./SharpDataService";
import * as RecentMoveDataService from "./RecentMoveDataService";
import * as ValueDataService from "./ValueDataService";
import * as DisplayService from "./DisplayService";
import * as StatDataService from "./StatDataService";
import * as RecordDataService from "./RecordDataService";

export default {
  ...SharpDataService,
  ...RecentMoveDataService,
  ...ValueDataService,
  ...DisplayService,
  ...StatDataService,
  ...RecordDataService,
};
